export default __webpack_public_path__ + "static/media/fi_chevrons-bottom.1543cf81.svg";